import '../../../ocom/static/js/ocom/ocom.module.js';
import '../../../ocom/static/js/ocom/services/platform.web.service';
import '../../../ocom/static/js/ocom/ocom.filters.js';
import '../../../ocom/static/js/ocom/ocom.config.js';
import './dexie_config.js';
import '../../../ocom/static/js/ocom/authentication/auth.alt.module.js';
import '../../../ocom/static/js/ocom/authentication/permission.service.ui-router.v1.0.js';
import '../../../ocom/static/js/ocom/authentication/role.service.js';
import '../../../ocom/static/js/ocom/services/alerts.service.js';
import '../../../ocom/static/js/ocom/services/input.service.js';
import '../../../ocom/static/js/ocom/services/stateStorage.service.ui-router-v1.0.js';
import '../../../ocom/static/js/ocom/services/cache.service.js';
import '../../../ocom/static/js/ocom/services/formstate.service.js';
import '../../../ocom/static/js/ocom/services/CodeTableCache.service.js';
import '../../../ocom/static/js/ocom/services/dataAPI.service.js';
import '../../../ocom/static/js/ocom/services/data.service.js';
import '../../../ocom/static/js/ocom/services/widget.service.js';
import '../../../ocom/static/js/ocom/widgets/forms/ocom-form-buttons.js';
import '../../../ocom/static/js/ocom/widgets/errors/show-errors.directive.js';
import '../../../ocom/static/js/ocom/widgets/ocom-create.js';
import '../../../ocom/static/js/ocom/widgets/ocom-table.js';
import '../../../ocom/static/js/ocom/widgets/ocom-list-group.directive.js';
import '../../../ocom/static/js/ocom/widgets/dates/ocom-datetime-picker.js';
import '../../../ocom/static/js/ocom/widgets/dates/ocom-required-datetime-picker.js';
import '../../../ocom/static/js/ocom/widgets/forms/input-focus.directive.js';
import '../../../ocom/static/js/ocom/widgets/forms/dirty-tracking.directive.js';
import '../../../ocom/static/js/ocom/widgets/forms/list.directive.js';
import '../../../ocom/static/js/ocom/widgets/forms/ocom-tags.directive.js';
import '../../../ocom/static/js/ocom/widgets/forms/location-field.directive';
import '../../../ocom/static/js/ocom/widgets/lists/sortable.directive.js';
import '../../../ocom/static/js/ocom/widgets/ui-select-infinite.directive.js';
import '../../../ocom/static/js/ocom/layout/footer.controller.js';
import '../../../ocom/static/js/ocom/layout/nav.controller.js';
import '../../../ocom/static/js/ocom/layout/content.controller.js';
import '../../../ocom/static/js/ocom/layout/resizer.directive.js';
import '../../../ocom/static/js/ocom/layout/scrollSync.directive.js';
import '../../../ocom/static/js/ocom/layout/profile/profile.controller.js';
import '../../../ocom/static/js/ocom/layout/profile/change_password.controller.js';

import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/forms/ocom-tags.directive.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/layout/content.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/layout/navbar.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/layout/footer.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/ocom-table.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/lists/sortable.directive.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/forms/ocom-form-buttons.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/dates/ocom-datetime-picker.html';
import '!ngtemplate-loader?relativeTo=/static/!html-loader!../../../ocom/static/js/ocom/widgets/dates/ocom-date-picker.html';